import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import techImage from "../assets/tech upskill.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
const Dashboard = () => {
  const [datas, setDatas] = useState([]);

  const getDataFromDB = useCallback(async () => {
    try {
      const response = await axios.get(
        "https://ask-questions-2d083-default-rtdb.firebaseio.com/posts.json"
      );
      const data = await response.data;
      let arrayT = [];
      for (let index in data) {
        arrayT.push({ index, ...data[index] });
      }
      setDatas(arrayT);
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  useEffect(() => {
    getDataFromDB();
  }, [getDataFromDB]);

  console.log(datas);

  function reduceWord(name) {
    return name.slice(0, 2);
  }

  return (
    <div>
      <div className="bg-black p-4 fixed w-full X">
        <div className="h-8">
          <img className=" h-full" src={techImage} alt={techImage} />
        </div>
      </div>
      <div className="flex flex-row pt-16 ">
        <div className="p-10 text-center fixed">
          <div className="text-3xl">Total Trainees</div>
          <div className="text-6xl font-bold">{datas.length}</div>
          <div className="fixed">
            {" "}
            <FontAwesomeIcon icon={faWarning} color="red" /> Hey We have
            duplicate we have do deal with it{" "}
          </div>
        </div>
        <div className="w-[700px] mx-auto my-8 pt-2 ">
          {datas.map((data) => {
            return (
              <div key={data.index} className=" flex flex-row p-2">
                <div className=" hover:bg-slate-700 rounded-full bg-slate-500 w-8 h-8 flex align-middle justify-center text-center pt-1 text-white uppercase">
                  {reduceWord(data.fullnames)}
                </div>
                <div className=" pl-4 mx-3 py-2 bg-slate-300 w-full rounded-lg hover:bg-[#a6bed1]">
                  <div className="font-medium text-xl">{data.fullnames}</div>
                  <a target="blank" href={data.repository}>
                    <div className="font-light text-blue-800">
                      {data.repository}
                    </div>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
